// iter91 — Page-scoped JSON-LD blobs (FAQPage, etc.) for SEO.
// Imported by individual page components and passed to `usePageSEO`.

export const LANDING_FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is MyLeaf Legacy?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'MyLeaf Legacy is a premium digital memorial platform. Each memorial is a permanent, shareable home for a loved one\'s life story — photos, life journey video, family tree, written stories, and a QR-engraved plaque that lives long after the funeral service is over.',
      },
    },
    {
      '@type': 'Question',
      name: 'How much does a MyLeaf memorial cost?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'There are two one-time packages: Memorial ($199) and Memorial Plus ($299). Memorial Plus adds an automated life-journey video, AI-narrated Life Story, and a private Family Vault. No subscriptions, no recurring fees — your memorial stays online forever.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does the QR plaque work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Every memorial comes with a complimentary aluminum QR plaque that scans to the public memorial page. Visitors at the gravesite, urn, or home altar can scan and instantly see the life journey video, photos, and family stories — no apps to download.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is the memorial private or public?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'You choose. Each memorial has a public-facing page (great for sharing with the wider community) and a private Family Vault (Memorial Plus) for documents, sensitive stories, and contact info that only invited family can see. You control every visibility setting.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can a funeral home or cemetery partner with MyLeaf?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Yes. MyLeaf partners with funeral homes, cemeteries, and memorial businesses through two tiers: Memorial Partners (direct $100 commission per family enrolment) and Regional Partners (lead a territory and earn override commissions on every Memorial Partner under their code). Apply at myleaflegacy.com/become-a-partner.',
      },
    },
  ],
};

export const PARTNER_FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'How does the MyLeaf partner program work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Two tiers. Memorial Partners (funeral homes, cemeteries, memorial businesses) earn a $100 commission for every family memorial they bring to the platform. Regional Partners lead a territory and earn a $25 override on every memorial enrolled under their Memorial Partners, for 12 months from approval.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is there a startup cost or monthly fee for partners?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'No. Joining is free. Partners only earn — they never pay MyLeaf. We pay commissions via Stripe Connect: either automatically per transaction (preferred) or manually batched monthly.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do partners get paid?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Through Stripe Connect. Once you complete the partner agreement and Stripe identity verification, commissions land in your bank account on the same schedule Stripe uses for your payouts (typically 2 business days after the family\'s payment clears).',
      },
    },
    {
      '@type': 'Question',
      name: 'Can I track my commissions?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'Yes. Your partner dashboard shows real-time stats: families enrolled, pending commissions, paid-out commissions, recruited Memorial Partners (for Regional Partners), and 12-month override contract dates. Every transaction is audited.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is a Regional Partner invite code?',
      acceptedAnswer: {
        '@type': 'Answer',
        text:
          'When you\'re approved as a Regional Partner, you receive a permanent 4-digit invite code (e.g. 3841). Memorial Partners who sign up with your code are automatically attributed to you for the 12-month override window. Share this code with funeral homes you bring on, or use the trackable invitation link from your dashboard.',
      },
    },
  ],
};
